import { render } from "./CompaniesTable.vue?vue&type=template&id=d6910428&scoped=true"
import script from "./CompaniesTable.vue?vue&type=script&lang=js"
export * from "./CompaniesTable.vue?vue&type=script&lang=js"

import "./CompaniesTable.vue?vue&type=style&index=0&id=d6910428&scoped=true&lang=css"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6910428"]])

export default __exports__